import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const GifColors = {
  lightGray: "#F0F4F6",
  green: "#00A14B",
  darkBlue: "#000564",
  israelBlue: "#0A46F0",
  lightBlue: "#F2F5FF",
  germanyYellow: "#FFDE17",
  germanyRed: "#ED1C24",
  germanyBlack: "#231F20",
  generalBlack: "#4B4B4B",
};

const GetTransparent = (color, transperancy = 41) =>
  `${color}${transperancy.toString(16)}`;

const createGifColor = (color) => ({
  hover: GetTransparent(color, 100),
  light: GetTransparent(color, 116),
  background: GetTransparent(color),
  color: color,
});

let main = createTheme({
  palette: {
    common: { white: "#ED1C24" },
    mode: "light",
    gif: {
      textBlue: createGifColor("#000564"),
      blue: createGifColor("#0A46F0"),
      red: createGifColor("#f00a1d"),
      green: { ...createGifColor("#00A14B"), dark: "#00A14B" },
      yellow: { ...createGifColor("#FFDE17"), dark: "#968100" },
      orange: { ...createGifColor("#F26522") },
    },
    background: {
      paper: "#fafafa",
      default: "#fff",
    },
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: "#FFF9D3",
          color: "black",
          textAlign: "center",
          fontFamily: ["Poppins", "sans-serif"].join(","),
          fontSize: "14px",
          borderRadius: "5px",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          fontSize: "16px",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*::-webkit-scrollbar": {
          width: "5px",
        },
        "*::-webkit-scrollbar-track": {
          WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
          backgroundColor: "transparent",
          borderRadius: 8,
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,.1)",
          borderRadius: "5px",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
  },
});
main = responsiveFontSizes(main);

export default main;
